import { render, staticRenderFns } from "./EditSetComponent.vue?vue&type=template&id=2ba5c75a"
import script from "./EditSetComponent.vue?vue&type=script&lang=js"
export * from "./EditSetComponent.vue?vue&type=script&lang=js"
import style0 from "./EditSetComponent.vue?vue&type=style&index=0&id=2ba5c75a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports